// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { Company, type CompanyWireFormat, NewCompany } from '../Company/Company';
import { type Contact, type ContactWireFormat, NewContact } from '../Contact/Contact';

export class ProjectConfigCompany {
  readonly company: Company;
  readonly contact: Contact | null;

  constructor(data: { [key: string]: any } = {}) {
    this.company = NewCompany(data.company);
    this.contact =
      // eslint-disable-next-line no-nested-ternary
      (data.contact ?? null) === null ? null : NewContact(data.contact);
  }

  static zero(): ProjectConfigCompany {
    const zeroValues: ExcludeMethodsDeep<ProjectConfigCompany> = {
      company: Company.zero(),
      contact: null,
    };
    return new ProjectConfigCompany(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ProjectConfigCompanyWireFormat = {
  company: CompanyWireFormat;
  contact: ContactWireFormat | null;
};

type NewProjectConfigCompanyProps = PartialDeep<ProjectConfigCompany, { recurseIntoArrays: true }>;
export const NewProjectConfigCompany: (
  props: NewProjectConfigCompanyProps,
) => ProjectConfigCompany = (props) => new ProjectConfigCompany(props);

type NewProjectConfigCompanyFromWireFormatProps = PartialDeep<
  ProjectConfigCompanyWireFormat,
  { recurseIntoArrays: true }
>;
export const NewProjectConfigCompanyFromWireFormat: (
  props: NewProjectConfigCompanyFromWireFormatProps,
) => ProjectConfigCompany = (props) => new ProjectConfigCompany(props);
